import { Component, Input, OnDestroy } from '@angular/core';
import { Color, forLifeOf, LifecycleAware } from '@lsq-frontend/common-ui';
import { Icons, ResponsiveService } from '@lsq-frontend/common-ui';

@LifecycleAware()
@Component({
    selector: 'available-funds-summary-expandable-container',
    template: `
        <div
            class="expandable-container"
            [ngClass]="{ 'internal-expandable': isInternalExpandable }"
        >
            <div
                class="expandable-container-header row"
                (click)="toggleExpanded()"
                [ngClass]="{ 'white-header': isInternalExpandable }"
            >
                <div class="col-6 col-md-8 expandable-container-left">
                    <div class="expandable-container-group">
                        <lsq-icon
                            class="expandable-container-icon"
                            [type]="isExpanded ? icons.ChevronDown : icons.ChevronRight"
                            [color]="color.Black"
                        >
                        </lsq-icon>
                        <div *ngIf="!isInternalExpandable" class="expandable-container-title">
                            {{ text }}
                        </div>
                        <h6
                            *ngIf="isInternalExpandable"
                            class="expandable-container-title internal"
                        >
                            {{ text }}
                        </h6>
                        <lsq-icon-popover *ngIf="popoverText && !isMobile" [text]="popoverText">
                        </lsq-icon-popover>
                    </div>
                </div>
                <div class="col-1 expandable-container-middle">
                    <lsq-icon
                        *ngIf="signIcon"
                        [type]="signIcon"
                        [color]="color.GrayDark"
                    ></lsq-icon>
                </div>
                <div *ngIf="!secondaryTotal" class="expandable-container-right col-5 col-md-3">
                    {{ primaryTotal | currency }}
                </div>
                <div *ngIf="secondaryTotal" class="expandable-container-right col-5 col-md-3">
                    <p class="expandable-primary">{{ primaryTotal | currency }}</p>
                    <h6 class="expandable-secondary">{{ secondaryTotal | currency }}</h6>
                </div>
            </div>
            <div *ngIf="isExpanded">
                <ng-content></ng-content>
            </div>
        </div>
    `,
    styleUrls: ['./available-funds-summary-expandable-container.component.scss']
})
export class AvailableFundsSummaryExpandableContainer implements OnDestroy {
    @Input() public text?: string;
    @Input() public popoverText?: string;
    @Input() public primaryTotal?: string;
    @Input() public secondaryTotal?: string;
    @Input() public isExpanded? = false;
    @Input() public signIcon?: string;
    @Input() public isInternalExpandable = false;

    public icons = Icons;
    public color = Color;
    public isMobile = false;

    constructor(private responsiveService: ResponsiveService) {}

    public ngOnInit(): void {
        this.responsiveService.smBelow.pipe(forLifeOf(this)).subscribe((isMobile) => {
            this.isMobile = isMobile;
        });
    }

    public ngOnDestroy(): void {}

    public toggleExpanded(): void {
        this.isExpanded = !this.isExpanded;
    }
}
